import { Button, Stack } from '@carbon/react'
import { Home, ArrowLeft, Search } from '@carbon/icons-react'
import { useNavigate, Link } from 'react-router-dom'
import styles from './NotFound.module.scss'

export default function NotFound() {
  const navigate = useNavigate()

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Stack gap={6}>
          <header className={styles.header}>
            <span className={styles.code} aria-hidden>
              404
            </span>
            <h1 className={styles.title}>Page introuvable</h1>
            <p className={styles.description}>
              La page que vous recherchez n'existe pas ou a été déplacée.
              Vérifiez l'URL ou retournez à l'accueil.
            </p>
          </header>

          <div className={styles.actions}>
            <Button
              kind="tertiary"
              renderIcon={ArrowLeft}
              onClick={() => navigate(-1)}
            >
              Retour
            </Button>
            <Button
              kind="primary"
              renderIcon={Home}
              onClick={() => navigate('/')}
            >
              Accueil
            </Button>
          </div>

          <div className={styles.helpBlock}>
            <Search size={20} className={styles.helpIcon} />
            <div className={styles.helpContent}>
              <p className={styles.helpTitle}>Besoin d'aide ?</p>
              <p className={styles.helpText}>
                Consultez le{' '}
                <Link to="/docs">centre d&apos;aide</Link> ou contactez le
                support si vous pensez qu&apos;il s&apos;agit d&apos;une erreur.
              </p>
            </div>
          </div>
        </Stack>
      </div>
    </div>
  )
}
